export const PREFIX_PHONE_NUMBER = {
  FR: "+33",
};
export const DOCUMENTS_MANAGER_POSTHOG_EVENTS = "ged";
